(() => {
  const CONFIG = {
    'calm-feeding-set': [
      { option: 'Slow Feeder Color', key: 'slow-feeder', label: 'Slow Feeder', handle: 'slow-feeder-bowl-for-cats-dogs-slower-calmer-mealtimes' },
      { option: 'Water Bowl Color', key: 'water-bowl', label: 'Water Bowl', handle: 'elevated-anti-splash-floating-cat-water-bowl' }
    ],
    'care-go-set': [
      { option: 'Bottle Color', key: 'bottle', label: 'Bottle', handle: 'portable-dog-water-bottle-with-food-storage-2-in-1-travel-bottle-for-dogs-cats' },
      { option: 'Brush Color', key: 'brush', label: 'Brush', handle: '3-in-1-pet-mist-grooming-brush-deshed-detangle-refresh' }
    ]
  };

  const CACHE = new Map();
  const norm = value => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const currentHandle = () => {
    const match = location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  };
  const legendName = group => (group?.querySelector('legend')?.textContent || '').split(':')[0].trim();
  const findGroup = (root, name) => [...root.querySelectorAll('.pl-option[data-option-position], [data-option-position]')]
    .find(group => norm(legendName(group)) === norm(name));
  const selectedValue = group => group?.querySelector('[data-option-value].is-selected')?.dataset.optionValue || '';
  const imageSrc = image => {
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.src || image.url || image.preview_image?.src || image.preview_image?.url || '';
  };
  const imageKey = src => {
    try {
      return new URL(src || '', location.origin).pathname.replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|x\d+)(?=\.[a-z0-9]+$)/i, '');
    } catch (_) { return String(src || '').split('?')[0]; }
  };
  const fetchProduct = handle => {
    if (!CACHE.has(handle)) {
      CACHE.set(handle, fetch(`/products/${handle}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(response => {
        if (!response.ok) throw new Error(`Unable to load ${handle}`);
        return response.json();
      }));
    }
    return CACHE.get(handle);
  };
  const colorIndex = product => {
    const options = product?.options || [];
    const index = options.findIndex(option => /colou?r/i.test(typeof option === 'string' ? option : option?.name || ''));
    return index >= 0 ? index : 0;
  };
  const colorVariant = (product, color) => {
    const index = colorIndex(product);
    const variants = product?.variants || [];
    return variants.find(variant => norm(variant.options?.[index]) === norm(color) && variant.available)
      || variants.find(variant => norm(variant.options?.[index]) === norm(color))
      || variants.find(variant => variant.available)
      || variants[0]
      || null;
  };
  const mediaList = product => (product?.media || []).map(media => ({
    src: imageSrc(media),
    alt: String(media?.alt || '').trim(),
    type: String(media?.media_type || media?.media_type || 'image').toLowerCase()
  })).filter(item => item.src && (!item.type || item.type === 'image'));

  const altGroup = (product, color) => {
    const wanted = norm(color);
    if (!wanted) return [];
    return mediaList(product).filter(item => norm(item.alt) === wanted);
  };

  const fallbackGroup = (product, color) => {
    const hero = imageSrc(colorVariant(product, color)?.featured_image);
    const variantHeroKeys = new Set((product?.variants || []).map(variant => imageKey(imageSrc(variant?.featured_image))).filter(Boolean));
    const shared = mediaList(product).filter(item => !variantHeroKeys.has(imageKey(item.src)));
    const result = [];
    const seen = new Set();
    [{ src: hero, alt: color }, ...shared].forEach(item => {
      if (!item?.src) return;
      const key = imageKey(item.src);
      if (!key || seen.has(key)) return;
      seen.add(key);
      result.push(item);
    });
    return result;
  };

  const groupForColor = (product, color) => {
    const exact = altGroup(product, color);
    return exact.length ? exact : fallbackGroup(product, color);
  };

  const ensureStyles = () => {
    if (document.getElementById('pl-bundle-alt-gallery-styles')) return;
    const style = document.createElement('style');
    style.id = 'pl-bundle-alt-gallery-styles';
    style.textContent = `
      .pl-gallery.pl-gallery--bundle-alt{display:block!important;width:100%!important;max-width:none!important}
      .pl-gallery.pl-gallery--bundle-alt>.pl-gallery__thumbs,
      .pl-gallery.pl-gallery--bundle-alt>.pl-gallery__stage{display:none!important}
      .pl-gallery.pl-gallery--bundle-alt>.pl-gallery__stack{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:14px!important;width:100%!important;max-width:none!important}
      .pl-gallery.pl-gallery--bundle-alt .pl-gallery__item{position:relative;aspect-ratio:1/1;margin:0;overflow:hidden;background:#f6f6f2}
      .pl-gallery.pl-gallery--bundle-alt .pl-gallery__stack-image{display:block;width:100%;height:100%;object-fit:contain;object-position:center}
      .pl-gallery.pl-gallery--bundle-alt .pl-gallery__item .pl-gallery__badge{position:absolute;left:18px;top:18px}
      @media(max-width:749px){
        .pl-gallery.pl-gallery--bundle-alt>.pl-gallery__stack{grid-template-columns:1fr!important;gap:12px!important}
        .pl-gallery.pl-gallery--bundle-alt .pl-gallery__item .pl-gallery__badge{left:14px;top:14px}
      }
    `;
    document.head.appendChild(style);
  };

  const init = async () => {
    const handle = currentHandle();
    const config = CONFIG[handle];
    const root = document.querySelector('[data-powlife-product]');
    if (!config || !root || root.dataset.bundleAltGalleryReady === 'true') return;

    const gallery = root.querySelector('.pl-gallery');
    if (!gallery) return;
    root.dataset.bundleAltGalleryReady = 'true';
    ensureStyles();

    const fallback = [...gallery.querySelectorAll('[data-gallery-thumb]')].map(thumb => ({
      src: thumb.dataset.src || thumb.querySelector('img')?.src || '',
      alt: thumb.dataset.galleryAlt || ''
    })).filter(item => item.src);
    const badge = gallery.querySelector('.pl-gallery__badge')?.cloneNode(true);
    let stack = gallery.querySelector('.pl-gallery__stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'pl-gallery__stack';
      gallery.prepend(stack);
    }
    gallery.classList.add('pl-gallery--bundle-alt');

    const loaded = {};
    await Promise.all(config.map(async item => {
      try { loaded[item.handle] = await fetchProduct(item.handle); }
      catch (_) { loaded[item.handle] = null; }
    }));

    const render = (items, label) => {
      const list = [];
      const seen = new Set();
      (items || []).forEach(item => {
        const entry = typeof item === 'string' ? { src: item, alt: '' } : item;
        if (!entry?.src) return;
        const key = imageKey(entry.src);
        if (!key || seen.has(key)) return;
        seen.add(key);
        list.push(entry);
      });
      const source = list.length ? list : fallback;
      if (!source.length) return;
      const frag = document.createDocumentFragment();
      source.forEach((item, index) => {
        const figure = document.createElement('figure');
        figure.className = 'pl-gallery__item';
        figure.dataset.bundleGalleryGroup = label || 'bundle';
        const img = document.createElement('img');
        img.className = 'pl-gallery__stack-image';
        img.src = item.src;
        img.alt = item.alt || `${label || 'Bundle'} - image ${index + 1}`;
        img.loading = index < 2 ? 'eager' : 'lazy';
        img.decoding = 'async';
        figure.appendChild(img);
        frag.appendChild(figure);
      });
      stack.replaceChildren(frag);
      if (badge && stack.firstElementChild) stack.firstElementChild.appendChild(badge.cloneNode(true));
    };

    let activeItem = config[0];
    let renderToken = 0;
    const show = item => {
      if (!item) return;
      const group = findGroup(root, item.option);
      const color = selectedValue(group);
      if (!color) return;
      activeItem = item;
      const product = loaded[item.handle];
      const token = ++renderToken;
      const items = product ? groupForColor(product, color) : [];
      if (token === renderToken) render(items, `${item.key}:${color}`);
    };

    render(fallback, 'bundle');
    show(activeItem);

    root.addEventListener('click', event => {
      const button = event.target.closest('[data-option-value]');
      if (!button || !root.contains(button)) return;
      const group = button.closest('.pl-option[data-option-position], [data-option-position]');
      const item = config.find(entry => findGroup(root, entry.option) === group);
      if (!item) return;
      activeItem = item;
      requestAnimationFrame(() => setTimeout(() => show(item), 0));
      setTimeout(() => show(item), 80);
      setTimeout(() => show(item), 180);
    }, true);

    root.addEventListener('change', event => {
      if (event.target.matches?.('[data-variant-select]')) setTimeout(() => show(activeItem), 60);
    }, true);

    document.addEventListener('powlife:bundle-refresh', () => setTimeout(() => show(activeItem), 60));
  };

  const boot = () => init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
